import { pathOr } from 'ramda';

import { IGetComparisonDesktopResponse } from '../../repositories/offers-comparison/entities/get_comparison_desktop/GetComparisonDesktopResponse';
import { IGeo, IOffer } from '../../types/offer';
import { IOfferDesktop } from '../../repositories/offers-comparison/entities/offer/OfferDesktop';
import { ECategory } from '../../types/category';
import { EDealType } from '../../types/dealType';
import { EOfferType } from '../../types/offerType';
import { transformComparisonNewbuilding } from './transformComparisonNewbuilding';
import { transformComparisonImages } from './transformComparisonImages';
import { transformComparisonFields } from './transformComparisonFields';
import { transformComparisonContacts } from './transformComparisonContacts';

export function transformComparisonOffers(response: IGetComparisonDesktopResponse): IOffer[] | null {
  if (!response.offers.length) {
    return null;
  }

  return response.offers.map((offer: IOfferDesktop): IOffer => {
    return {
      /** Аналитика **/
      analytics: offer.analytics,
      /** Площади объявления **/
      area: offer.area,
      /** Количество балконов и лоджий **/
      balconies: pathOr(null, ['balconies'], offer),
      /** Год постройки **/
      buildYear: pathOr(null, ['buildYear'], offer),
      /** Застройщик **/
      builder: offer.builder,
      /** Категория **/
      category: offer.category as ECategory,
      /** Новостройка или вторичка **/
      categoryName: pathOr(null, ['categoryName'], offer),
      /** Высота потолков, м **/
      ceilingHeight: pathOr(null, ['ceilingHeight'], offer),
      /** Контакты **/
      contacts: transformComparisonContacts(offer),
      /** Тип сделки **/
      dealType: offer.dealType as EDealType,
      /** Список непустых строк таблицы с атрибутами объявления (для оптимизации фронта) **/
      fields: transformComparisonFields(offer),
      /** Этаж **/
      floor: offer.floor,
      /** Гео **/
      geo: offer.geo as IGeo,
      /** ID **/
      id: offer.id,
      /** Изображения **/
      images: transformComparisonImages(offer),
      /** В избранном ли объявление у пользователя **/
      isFavorite: offer.isFavorite,
      /** Лифты **/
      lifts: pathOr(null, ['lifts'], offer),
      /** Возможна ли ипотека **/
      mortgage: pathOr(null, ['mortgage'], offer),
      /** ЖК **/
      newbuilding: transformComparisonNewbuilding(offer),
      /** Корпус ЖК **/
      newbuildingHouse: offer.newbuildingHouse,
      /** Тип объявления **/
      offerType: offer.offerType as EOfferType,
      /** Цена **/
      price: offer.price,
      /** Опубликовано ли объявление **/
      published: offer.published,
      /** Тип ремонта **/
      repairType: pathOr(null, ['repairType'], offer),
      /** Заголовок ('2-комн. апарт., 111,9 м², 9/10') **/
      title: offer.title,
      /** Url карточки **/
      url: offer.url,
      /** Санузел **/
      wc: pathOr(null, ['wc'], offer),
      /** Вид из окон **/
      windowsView: offer.windowsView,
    };
  });
}
